import {
    DeleteImageIconButton,
    ImagePreviewContainer,
    ImagePreviewItem,
    ImageOverlay,
    UploadIndicator,
    RetryButton,
    RetryIndicator,
} from "./PostForm.styles";
import XmarkSvg from "jsx:../../../../Images/Icons/FontAwesome/light/xmark.svg";
import { useContext } from "react";
import { SortableItemContext } from "../../SortableList/SortableItem";
import { ImageItemType } from "./PostFormModal.types";

export default function ImageItem(props: ImageItemType) {
    const { attributes, listeners, ref } = useContext(SortableItemContext);
    const imageUrl =
        props.image.mediaType === "video"
            ? props.image.videoThumbnailUrl
            : props.image.imageUrl;
    return (
        <ImagePreviewContainer>
            <DeleteImageIconButton
                disabled={props.image.isUploading}
                children={<XmarkSvg />}
                onClick={() => {
                    props.handleOnRemoveImage(props.itemKey - 1);
                }}
            />
            <ImagePreviewItem
                image={imageUrl ?? undefined}
                {...attributes}
                {...listeners}
                ref={ref}
            ></ImagePreviewItem>
            {props.image.isUploading && (
                <ImageOverlay>
                    <UploadIndicator />
                </ImageOverlay>
            )}
            {props.image.failed && (
                <ImageOverlay>
                    <RetryButton
                        onClick={() => {
                            props.handleImageUploadRetry(props.image);
                        }}
                    >
                        <RetryIndicator />
                    </RetryButton>
                </ImageOverlay>
            )}
        </ImagePreviewContainer>
    );
}
